import Vue from 'vue';

/**
 * Global Events
 */

const GlobalEvents = {
  dismissAblePopUpOpen: 'DismissAblePopUpOpen',
  dismissAblePopUpClosed: 'DismissAblePopUpClosed',
  pageIdentifyingDataUpdated: 'PageIdentifyingDataUpdated',
  menuItemClicked: 'menuItemClicked',
  upgradedToPremium: 'upgradedToPremium',
  upgradingToPremiumFailed: 'upgradingToPremiumFailed',
};

/**
 * Global Event Bus
 */
export const EventBus = new Vue({
  data: {
    events: GlobalEvents,
  },
});
